module.exports = __webpack_public_path__ + "img/product_38.6f93108.webp";